import {
	AddOrUpdateCreditCardResponse,
	CalculateProratedTotalResponse,
	CancelCreditCardSetupIntentResponse,
	CreateAddSeatsPaymentIntentResponse,
	CreateCreditCardSetupIntentResponse,
	GetCompanyBillingSettingsResponseFrontend,
} from "@performyard/service-contracts";

import request from "./internal-base-request";

export const getCompanyBillingInfo = async () => {
	return await request<GetCompanyBillingSettingsResponseFrontend>("/v1/billing/configuration");
};

export const calculateProratedTotal = async (quantity: string) => {
	const response = await request<CalculateProratedTotalResponse>(`/v1/billing/seats/price?quantity=${quantity}`);
	return response?.[0];
};

export const createAddSeatsPaymentIntent = async (props: { quantity: string; totalAmount: string }) => {
	const response = await request<CreateAddSeatsPaymentIntentResponse>("/v1/billing/seats/purchase", {
		method: "POST",
		body: JSON.stringify({
			quantity: props.quantity,
			totalAmount: props.totalAmount,
		}),
	});
	return response?.[0];
};

export const createCreditCardSetupIntent = async () => {
	const response = await request<CreateCreditCardSetupIntentResponse>("/v1/billing/payment-methods/setup", {
		method: "POST",
		body: JSON.stringify({}),
	});
	return response?.[0].setupIntent || {};
};

export const cancelCreditCardSetupIntent = async (setupIntentId: string) => {
	const response = await request<CancelCreditCardSetupIntentResponse>("/v1/billing/payment-methods/cancel", {
		method: "POST",
		body: JSON.stringify({
			setupIntentId,
		}),
	});
	return response?.[0].setupIntent || {};
};

export const addOrUpdateCreditCard = async (paymentMethodId: string) => {
	const response = await request<AddOrUpdateCreditCardResponse>("/v1/billing/payment-methods", {
		method: "PUT",
		body: JSON.stringify({
			paymentMethodId,
		}),
	});
	return response?.[0];
};
